module.exports = __webpack_public_path__ + "img/package_2_outlined.8ed25ac0.svg";